// extracted by mini-css-extract-plugin
export default {"box":"TopRowInput_box__wkrNF","input":"TopRowInput_input__qfgDX"};